<template>
  <div class="editor-module-container" :class="`theme-${personInfo.theme || 'default'}`">
    <div class="editor-module-title">
      <div class="flex items-center">
        <img v-if="moduleIcon" class="module-icon" :src="moduleIcon" alt="" />
        {{ cvDetail.basic_info.lang === 'en' ? 'PERSONAL INFORMATION' : '基本信息' }}
        <div v-if="issueCount" class="module-issue-count" @click.stop="clickIssueCount">
          {{ issueCount }} 项待修复
        </div>
      </div>
      <div
        class="iconfont-content"
        :class="{ active: editId === 'profile' }"
        @click="profileCollapseChange"
      >
        <i class="iconfont iconchevron-down"></i>
      </div>
    </div>
    <div class="editor-form-content" @click="profileCollapseChange">
      <div v-if="editId !== 'profile'" class="form-item-header">
        <div class="form-item-title">
          <div class="form-item-name">
            {{ profile.username }}
          </div>
        </div>
        <div v-if="profile.phone || profile.email || profile.current_job" class="form-item-content">
          <div v-if="profile.phone" class="content-text">
            {{ profile.phone }}
          </div>
          <div v-if="profile.email" class="content-text">
            {{ profile.email }}
          </div>
          <div v-if="profile.current_job" class="content-text">
            {{ profile.current_job }}
          </div>
        </div>
      </div>
      <el-collapse-transition>
        <div v-show="editId === 'profile'" class="edit-profile-module" @click.stop>
          <div class="editor-module-content">
            <EditorInput v-model="profile.username" label="姓名" clearable />
            <div
              class="avatar-container"
              style="width: 232px; padding-left: 14px; box-sizing: border-box"
            >
              <div class="avatar-content">
                <img v-if="profile.avatar_url" :src="profile.avatar_url" alt="" />
                <i
                  v-else
                  class="iconxinjianjianli iconfont cursor-pointer"
                  @click="showAvatarUploadModal"
                ></i>
              </div>
              <div class="avatar-upload">
                <div
                  v-if="profile.avatar_url"
                  class="avatar-upload-text delete-btn"
                  @click="deleteAvatar"
                >
                  删除
                </div>
                <div
                  class="avatar-upload-text"
                  :class="profile.avatar_url ? 'replace-btn' : 'upload-btn'"
                  @click="showAvatarUploadModal"
                >
                  {{ profile.avatar_url ? '更换头像' : '添加头像' }}
                </div>
              </div>
            </div>
            <EditorInput v-model="profile.phone" label="电话" clearable />
            <EditorInput v-model="profile.email" label="邮箱" clearable />
            <EditorInput
              v-model="profile.address"
              label="现居城市"
              placeholder="如：北京"
              style="flex: 1"
              clearable
            />
            <div v-for="item in socialList.filter((value) => value.display)" :key="item.key">
              <EditorSelect
                v-if="item.type === 'select'"
                v-model="profile[item.key]"
                :label="item.label"
                :options="item.options"
                :placeholder="item.placeholder"
                clearable
              />

              <EditorInput
                v-else
                v-model="profile[item.key]"
                :label="item.label"
                :placeholder="item.placeholder"
                clearable
              />
            </div>
            <div v-for="item in otherList.filter((value) => value.display)" :key="item.key">
              <EditorSelect
                v-if="item.type === 'select'"
                v-model="profile[item.key]"
                :label="item.label"
                :options="item.options"
                :placeholder="item.placeholder"
                clearable
              />
              <div v-else-if="item.key === 'birthday'" class="age-birthday-container">
                <EditorDatePicker
                  ref="birthdayPicker"
                  v-model="profile[item.key]"
                  :label="item.label"
                  :placeholder="item.placeholder"
                  clearable
                />
                <div
                  v-if="currentAge && ageOrBirthdayPicker === 'age'"
                  class="age-birthday-text"
                  @click="datePickerFocus"
                >
                  {{ currentAge }}
                </div>
                <EditorLabelsPicker
                  class="age-birthday-picker"
                  :value="ageOrBirthdayPicker"
                  :list="[
                    { label: '年龄', value: 'age' },
                    { label: '生日', value: 'birthday' },
                  ]"
                  singlePicker
                  @clickItem="clickAgeOrBirthdayPicker"
                />
              </div>
              <EditorInput
                v-else
                v-model="profile[item.key]"
                :label="item.label"
                :placeholder="item.placeholder"
                clearable
              />
            </div>
          </div>
          <div class="form-title">求职意向</div>
          <div class="editor-module-content">
            <EditorInput
              v-model="profile.current_job"
              label="当前状态"
              placeholder="如：在职，看看机会"
              clearable
              @focus="
                () => {
                  currentJobPickerVisible = true;
                }
              "
              @blur="currentJobInputBlur"
            />
            <EditorInput
              v-model="profile.exp_city"
              label="意向城市"
              placeholder="请填写意向城市"
              clearable
            />
            <div v-show="currentJobPickerVisible" class="current-job-picker">
              <div
                v-for="(item, index) in currentJobList"
                :key="index"
                class="current-job-item"
                :class="{ active: profile.current_job === item }"
                @click.stop="clickCurrentJob(item)"
              >
                {{ item }}
              </div>
            </div>
            <EditorInput
              v-model="profile.exp_job"
              label="期望职位"
              clearable
              placeholder="请填写期望职位"
            />
            <div class="salary-container flex flex-col">
              <div class="salary-title">期望薪资</div>
              <div class="salary-content flex items-center">
                <EditorSelect
                  v-model="expectSalary.min"
                  :options="minSalaryOptions"
                  placeholder="最低薪资"
                  clearable
                  @change="expectSalaryChange('min')"
                />
                <template v-if="expectSalary.min < 100">
                  <span class="salary-item-text">至</span>
                  <EditorSelect
                    v-model="expectSalary.max"
                    :options="maxSalaryOptions"
                    placeholder="最高薪资"
                    clearable
                    @change="expectSalaryChange('max')"
                  />
                </template>
              </div>
            </div>
          </div>
          <EditorLabelPickerList
            title="社交信息"
            :list="displaySocialLabelList"
            style="margin-top: 36px"
            @clickPickerItem="clickPickerItem"
          />
          <EditorLabelPickerList
            title="其他信息"
            :list="displayOtherLabelList"
            style="margin-top: 36px"
            @clickPickerItem="clickPickerItem"
          />
          <CheckSuggestionList
            class="profile-issue-list"
            style="padding-top: 36px"
            :list="suggestionsModule ? suggestionsModule.basic_info : []"
            hiddenBottomBtn
            @clickIgnore="clickIgnore($event, 'basic_info')"
          />
          <CheckSuggestionList
            class="profile-issue-list"
            :list="suggestionsModule ? suggestionsModule.profile : []"
            :style="{ paddingTop: '10px' }"
            hiddenBottomBtn
            @clickIgnore="clickIgnore($event, 'profile')"
          />
          <div class="complete-button-wrapper" style="margin-top: 36px">
            <CompleteButton text="保存" @clickBtn="saveProfileData" />
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <UploadAvatarModal ref="uploadAvatarModal" />
  </div>
</template>
<script>
import api from '@/api';
import { mapState } from 'vuex';
import EditorInput from '../EditorInput/EditorInput.vue';
import EditorSelect from '../EditorSelect/EditorSelect.vue';
import EditorDatePicker from '../EditorDatePicker/EditorDatePicker.vue';
import EditorLabelPickerList from '../EditorLabelPickerList/EditorLabelPickerList.vue';
import EditorLabelsPicker from '../EditorLabelsPicker/EditorLabelsPicker.vue';
import CheckSuggestionList from '../CheckSuggestionList/CheckSuggestionList.vue';
import UploadAvatarModal from '../UploadAvatarModal/index.vue';
import { debounce } from '@/assets/js/util';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import { uploadMixin } from '../../mixins/upload';

let timer = null;

const SOCIAL_LIST = [
  {
    label: '个人网站',
    key: 'homepage',
    display: false,
    placeholder: '如：github.com/wondercv',
  },
  {
    label: '微信',
    key: 'wechat',
    display: false,
    placeholder: '请填写',
  },
  {
    label: 'LinkedIn',
    key: 'linked_in',
    display: false,
    placeholder: '请填写领英账号',
  },
];

const OHTER_LIST = [
  {
    label: '性别',
    key: 'gender',
    display: false,
    placeholder: '请选择性别',
    type: 'select',
    options: [
      { label: '男', value: '男' },
      { label: '女', value: '女' },
    ],
  },
  {
    label: '身高',
    key: 'height',
    display: false,
    placeholder: '如：180cm',
  },
  {
    label: '体重',
    key: 'weight',
    display: false,
    placeholder: '如：60kg',
  },
  {
    label: '民族',
    key: 'ethnic',
    display: false,
    placeholder: '如：汉族',
  },
  {
    label: '籍贯',
    key: 'hometown',
    display: false,
    placeholder: '请填写籍贯',
  },
  {
    label: '政治面貌',
    key: 'political_status',
    display: false,
    type: 'select',
    placeholder: '请选择政治面貌',
    options: [
      { label: '中共党员', value: '中共党员' },
      { label: '中共预备党员', value: '中共预备党员' },
      { label: '共青团员', value: '共青团员' },
      { label: '群众', value: '群众' },
    ],
  },
  {
    label: '婚姻状况',
    key: 'marriage',
    display: false,
    placeholder: '请填写',
  },
  {
    label: '年龄或生日',
    key: 'birthday',
    display: false,
    placeholder: '请选择年龄或生日',
    type: 'date',
  },
];

const moment = require('moment');

export default {
  name: 'EditorProfile',
  mixins: [uploadMixin],
  components: {
    EditorInput,
    EditorSelect,
    EditorLabelPickerList,
    EditorDatePicker,
    EditorLabelsPicker,
    CompleteButton,
    UploadAvatarModal,
    CheckSuggestionList,
  },
  props: {
    editId: {
      type: [String, Number],
      default: '',
    },
    suggestionsModule: {
      type: Object,
      default: () => ({}),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    moduleIcon: {
      type: String,
      default: '',
    },
    issueCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentJobList: [
        '在职',
        '离职',
        '应届生',
        '在职，正在找工作',
        '待业',
        '在读',
        '应届毕业生',
        '离职，随时到岗',
        '在校生',
        '随时到岗',
        '正在找工作',
        '求职中',
        '实习中',
        '在职，考虑机会',
        '在职，月内到岗',
      ],
      currentJobPickerVisible: false,
      socialList: [],
      otherList: [],
      expectSalary: {
        min: '',
        max: '',
      },
    };
  },
  watch: {
    editId(_, oldVal) {
      if (oldVal === 'profile') {
        this.saveProfileData();
      }
    },
    profile: {
      handler(newVal, oldVal) {
        if ((oldVal && Object.keys(oldVal).length === 0) || !oldVal) {
          this.socialList = this.initPickerListShow(SOCIAL_LIST);
          this.otherList = this.initPickerListShow(OHTER_LIST);
        }
        if (newVal.expected_salary) {
          const [min, max] = newVal.expected_salary.split('-');
          if (min) {
            this.expectSalary.min = Number(min.slice(0, -1));
          }
          if (max) {
            this.expectSalary.max = Number(max.slice(0, -1));
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('editor', ['profile', 'cvDetail']),
    ...mapState('me', ['personInfo']),
    displaySocialLabelList() {
      return this.socialList.filter((item) => !item.display);
    },
    displayOtherLabelList() {
      return this.otherList.filter((item) => !item.display);
    },
    ageOrBirthdayPicker() {
      return this.profile?.format_pref?.age_birthday?.chosen || 'age';
    },
    minSalaryOptions() {
      return Array.from({ length: 100 }, (_, index) => ({
        label: index === 99 ? '100k以上' : `${index + 1}k`,
        value: index + 1,
      }));
    },
    maxSalaryOptions() {
      if (this.expectSalary.min === 100 || this.expectSalary.min === '') {
        return [];
      }
      const maxLength = Math.min(100 - this.expectSalary.min, 3);
      if (maxLength === 0) {
        return [];
      }
      return Array.from({ length: maxLength }, (_, index) => ({
        label: `${index + this.expectSalary.min + 1}k`,
        value: index + this.expectSalary.min + 1,
      }));
    },
    currentAge() {
      const {
        basic_info: { lang },
      } = this.cvDetail;
      const { birthday } = this.profile;
      //判断是否选择的生日
      if (this.ageOrBirthdayPicker === 'birthday') {
        return birthday;
      } else {
        if (birthday) {
          return `${moment().diff(birthday, 'years')}${lang === 'cn' ? '岁' : ''}`;
        }
        return '';
      }
    },
  },
  methods: {
    clickIssueCount() {
      const editId = this.editId;
      this.editIdChange();
      this.$nextTick(() => {
        const timer = setTimeout(
          () => {
            const moduleEl = document.querySelector('.edit-profile-module');
            if (moduleEl) {
              const issueEl = moduleEl.querySelector('.suggestion-list-container');
              issueEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            clearTimeout(timer);
          },
          editId === 'profile' ? 0 : 1000,
        );
      });
    },
    profileCollapseChange() {
      if (window.location.href.includes('mentor')) return;
      if (this.editId === 'profile') {
        this.$emit('editItem', '');
      } else {
        this.editIdChange();
      }
    },
    async clickIgnore(issueItem, type) {
      try {
        const payload = {
          cv_token: this.cvDetail.basic_info.token,
          cv_module_data: {},
          module_name: type,
          index: issueItem.index,
        };
        const res = await api.cvsEditor.ignoreCheckIssue(payload);
        if (res.code === 1000) {
          this.$message.success('已忽略');
          issueItem.status = 'obsolete';
          this.$emit('refreshCheckResult');
        }
      } catch (error) {
        console.log(error);
      }
    },
    showAvatarUploadModal() {
      this.$store.commit('editor/setPortraitDialogVisible', true);
    },
    async deleteAvatar() {
      const confirm = await this.$wondercv.showConfirm({
        title: '删除提示',
        content: '确定要删除头像吗？',
        confirmText: '删除',
        warningText: '删除后将无法恢复',
      });
      if (confirm) {
        this.profile.avatar_url = '';
        this.saveProfileData();
      }
    },
    initPickerListShow(list) {
      list.forEach((item) => {
        item.display = !!this.profile[item.key];
      });
      return list;
    },
    clickCurrentJob(item) {
      this.profile.current_job = item;
    },
    currentJobInputBlur() {
      timer = setTimeout(() => {
        this.currentJobPickerVisible = false;
        clearTimeout(timer);
      }, 200);
    },
    clickPickerItem(item) {
      item.display = true;
      this.editIdChange();
    },
    clickAgeOrBirthdayPicker(item) {
      this.editIdChange();
      this.profile.format_pref = {
        ...this.profile.format_pref,
        age_birthday: {
          chosen: item,
        },
      };
    },
    datePickerFocus() {
      this.$refs.birthdayPicker?.[0]?.datePickerFocus?.();
      this.editIdChange();
    },
    editIdChange() {
      this.$emit('editItem', 'profile');
    },
    expectSalaryChange(type) {
      if (type === 'min') {
        this.expectSalary.max = '';
      }
      const minText =
        this.expectSalary.min === 100
          ? '100k以上'
          : this.expectSalary.min
          ? `${this.expectSalary.min}k`
          : '';
      const maxText = this.expectSalary.max === '' ? '' : `${this.expectSalary.max}k`;
      this.profile.expected_salary = `${minText}${maxText ? `-${maxText}` : ''}`;
    },
    async updateProfileData() {
      try {
        delete this.profile.show_attr_name;
        return await this.$store.dispatch('editor/updateProfileData', {
          payload: this.profile,
          displayLoading: false,
          skipCheck: true,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async createProfileData() {
      try {
        delete this.profile.show_attr_name;
        return await this.$store.dispatch('editor/createProfileData', {
          payload: this.profile,
          displayLoading: false,
          skipCheck: true,
        });
      } catch (error) {
        console.log(error);
      }
    },
    saveProfileData: debounce(async function () {
      if (this.saveLoading) return;
      this.$emit('changeSaveLoading', true);
      // const loading = this.$message({
      //   iconClass: "el-icon-loading",
      //   duration: 0,
      //   message: "正在保存",
      // });
      const { basic_info } = this.cvDetail;
      let res = null;
      if (['template', 'sample'].includes(basic_info.kind)) {
        // 创建简历后创建profile
        res = await this.$store.dispatch('editor/createCvDetail', {
          payload: this.cvDetail,
          dontReload: true,
          displayLoading: false,
        });
        if (res.code === 1000) {
          const result = await this.createProfileData();
          this.$emit('changeSaveLoading', false);
          // if (result.code === 1000) {
          //   this.$router.replace({
          //     path: `/cvs/${result.data.basic_info?.token}/editor`,
          //   });
          //   this.$emit('changeSaveLoading', false);
          // }
        }
      } else if (!this.profile.id) {
        res = await this.createProfileData();
      } else {
        res = await this.updateProfileData();
      }
      if (res.code === 1000) {
        this.$emit('editItem', '');
        // this.$message.success('保存成功');
      }
      this.$emit('changeSaveLoading', false);
      // loading.close();
    }, 300),
  },
  beforeDestroy() {
    clearTimeout(timer);
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/editor.scss';
@import '@/assets/css/variable.scss';
.iconfont-content {
  cursor: pointer;
  color: #8d99aa;
  transition: transform 0.3s;
  transform: rotate(0deg);
  &:hover {
    color: $hover-icon-color;
  }
  &.active {
    transform: rotate(180deg);
  }
}
.avatar-container {
  display: flex;
  align-items: center;
  .avatar-content {
    width: 55px;
    height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
    background-color: $upload-bg-color;
    img {
      width: 100%;
      object-fit: cover;
    }
    .iconxinjianjianli {
      color: #6e7788;
      font-size: 24px;
    }
  }
  .avatar-upload {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    .avatar-upload-text {
      font-size: 14px;
      cursor: pointer;
      &:nth-child(2) {
        margin-top: 14px;
      }
      &.delete-btn {
        color: $delete-btn-color;
      }
      &.replace-btn {
        color: $replace-btn-color;
      }
      &.upload-btn {
        color: $theme-color;
      }
    }
  }
}
.form-title {
  font-size: 16px;
  color: $text-color;
  font-weight: 600;
  margin-bottom: 24px;
  margin-top: 36px;
}
.current-job-picker {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .current-job-item {
    cursor: pointer;
    padding: 4px 12px;
    border-radius: 14px;
    border: 1px solid $label-border-color;
    margin-right: 10px;
    margin-bottom: 8px;
    font-size: 14px;
    color: $label-text-color;
    line-height: 20px;

    &:hover,
    &.active {
      color: #ff6644;
      border-color: #ff6644;
    }
  }
}
.salary-container {
  width: 232px;
  .salary-title {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .salary-content {
    .salary-item-text {
      color: $form-label-color;
      margin: 0 8px;
    }
  }
}
.age-birthday-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .age-birthday-text {
    position: absolute;
    height: 36px;
    background-color: $page-bg-sub-color;
    color: $text-color;
    width: calc(100% - 90px);
    top: 35px;
    left: 15px;
    display: flex;
    align-items: center;
  }
  .age-birthday-picker {
    margin-top: 12px;
    ::v-deep(.select-item) {
      height: 22px;
      font-size: 12px;
      padding: 0 12px;
    }
  }
}
</style>
